import { TThunkAction } from '../../../common/types/thunk';
import { ERecommendedPackageType } from '../../types/reducers/recommendedPackages';
import { buyCustomPackageThunk } from './buyCustomPackage';
import { buyPackageThunk } from './buyPackage';
import { selectActiveRecommendedPackage } from '../../reducers/v2/recommendedPackages/selectors';

export const runBuyPackageLegacyThunk =
  (): TThunkAction =>
  (dispatch, getState, { logger }) => {
    const state = getState();

    const recommendedPackage = selectActiveRecommendedPackage(state);

    logger.debug('runBuyPackageLegacyThunk', { recommendedPackage: JSON.stringify(recommendedPackage) });

    if (!recommendedPackage) {
      return;
    }

    if (recommendedPackage.packageType === ERecommendedPackageType.Custom) {
      dispatch(buyCustomPackageThunk());

      return;
    }

    dispatch(buyPackageThunk());
  };
